import React, { useState } from 'react';
import { Modal, Button, Form, Card } from 'react-bootstrap';

const TermsAndConditions = ({ acceptTerms, setAcceptTerms }) => {
  const [showModal, setShowModal] = useState(false);
  
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  
  return (
    <>
      <Card className="bg-light mb-4">
        <Card.Body>
          <Form.Group controlId="termsCheckbox">
            <Form.Check
              type="checkbox"
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)}
              label={
                <span>
                  I have read and agree to the <Button 
                    variant="link" 
                    className="p-0" 
                    onClick={handleShowModal}
                    style={{ verticalAlign: 'baseline', fontSize: 'inherit' }}
                  >
                    Privacy Policy and Terms of Service
                  </Button>
                </span>
              }
              required
            />
          </Form.Group>
          <small className="text-muted d-block mt-2">
            By checking this box, you consent to our collection and use of your personal information as described in our Privacy Policy.
          </small>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Privacy Policy & Terms of Service</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <h4>HIPAA Notice of Privacy Practices</h4>
          <p>This notice describes how medical information about you may be used and disclosed and how you can get access to this information. Please review it carefully.</p>
          
          <h5>Understanding Your Health Record Information</h5>
          <p>Each time you visit a healthcare provider, a record of your visit is made. This record contains your symptoms, examination and test results, diagnoses, treatment, and a plan for future care. This information, often referred to as your health or medical record, serves as a:</p>
          <ul>
            <li>Basis for planning your care and treatment</li>
            <li>Means of communication among the health professionals who contribute to your care</li>
            <li>Legal document describing the care you received</li>
            <li>Means by which you or a third-party payer can verify that services billed were actually provided</li>
            <li>Tool for education of healthcare professionals</li>
            <li>Source of data for medical research, public health officials, and facility planning</li>
          </ul>
          
          <h5>Your Health Information Rights</h5>
          <p>You have the right to:</p>
          <ul>
            <li>Request a restriction on certain uses and disclosures of your information</li>
            <li>Obtain a paper copy of the notice of privacy practices upon request</li>
            <li>Inspect and obtain a copy of your health record</li>
            <li>Request to amend your health record</li>
            <li>Obtain an accounting of disclosures of your health information</li>
            <li>Request communications of your health information by alternative means or at alternative locations</li>
            <li>Revoke your authorization to use or disclose health information except to the extent that action has already been taken</li>
          </ul>
          
          <h5>Our Responsibilities</h5>
          <p>This organization is required to:</p>
          <ul>
            <li>Maintain the privacy of your health information</li>
            <li>Provide you with a notice as to our legal duties and privacy practices with respect to information we collect and maintain about you</li>
            <li>Abide by the terms of this notice</li>
            <li>Notify you if we are unable to agree to a requested restriction</li>
            <li>Accommodate reasonable requests you may have to communicate health information by alternative means or at alternative locations</li>
          </ul>
          
          <h5>For More Information or to Report a Problem</h5>
          <p>If you have questions and would like additional information, you may contact the practice's Privacy Officer.</p>
          
          <h5>Electronic Communication Consent</h5>
          <p>By providing your email address and phone number, you consent to receive electronic communications related to your care, including but not limited to appointment reminders, billing information, and health information.</p>
          
          <h5>Data Security</h5>
          <p>We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information. However, no method of electronic storage is 100% secure, and we cannot guarantee its absolute security.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={() => {
            setAcceptTerms(true);
            handleCloseModal();
          }}>
            I Accept
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TermsAndConditions;